var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaintAirQualityComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1908_26811)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_26811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1908_26811)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1908_26811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9089 31.6844H29.5755C29.2219 31.6844 28.8828 31.8319 28.6327 32.0944C28.3827 32.357 28.2422 32.7131 28.2422 33.0844C28.2422 33.4557 28.3827 33.8118 28.6327 34.0743C28.8828 34.3369 29.2219 34.4844 29.5755 34.4844H36.9089C37.7929 34.4844 38.6408 34.1156 39.2659 33.4592C39.891 32.8029 40.2422 31.9126 40.2422 30.9844C40.2422 30.0561 39.891 29.1659 39.2659 28.5095C38.6408 27.8531 37.7929 27.4844 36.9089 27.4844H36.2422C35.8886 27.4844 35.5494 27.6319 35.2994 27.8944C35.0493 28.157 34.9089 28.5131 34.9089 28.8844C34.9089 29.2557 35.0493 29.6118 35.2994 29.8743C35.5494 30.1369 35.8886 30.2844 36.2422 30.2844H36.9089C37.0857 30.2844 37.2552 30.3581 37.3803 30.4894C37.5053 30.6207 37.5755 30.7987 37.5755 30.9844C37.5755 31.17 37.5053 31.3481 37.3803 31.4793C37.2552 31.6106 37.0857 31.6844 36.9089 31.6844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7422 38.4844H32.7422C33.14 38.4844 33.5215 38.3263 33.8028 38.045C34.0842 37.7637 34.2422 37.3822 34.2422 36.9844C34.2422 36.5866 34.0842 36.205 33.8028 35.9237C33.5215 35.6424 33.14 35.4844 32.7422 35.4844H29.7422C29.3444 35.4844 28.9628 35.6424 28.6815 35.9237C28.4002 36.205 28.2422 36.5866 28.2422 36.9844C28.2422 37.3822 28.4002 37.7637 28.6815 38.045C28.9628 38.3263 29.3444 38.4844 29.7422 38.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0422 35.8177H37.6422C37.2709 35.8177 36.9148 35.9582 36.6522 36.2082C36.3897 36.4583 36.2422 36.7974 36.2422 37.151C36.2422 37.5047 36.3897 37.8438 36.6522 38.0939C36.9148 38.3439 37.2709 38.4844 37.6422 38.4844H46.0422C47.1561 38.4844 48.2244 38.0629 49.012 37.3128C49.7997 36.5627 50.2422 35.5452 50.2422 34.4844V33.8177C50.2433 33.3798 50.1534 32.946 49.9775 32.5414C49.8016 32.1368 49.5432 31.7694 49.2174 31.4604C48.5558 30.8467 47.6726 30.4975 46.7492 30.4844H46.7324C46.0261 30.4964 45.3375 30.6971 44.7452 31.0636C44.1529 31.4302 43.6806 31.9479 43.3822 32.5577C43.217 32.8746 43.1906 33.2409 43.3091 33.5762C43.4275 33.9116 43.6809 34.1883 44.0136 34.3457C44.3463 34.5031 44.731 34.5281 45.083 34.4153C45.4351 34.3026 45.7258 34.0612 45.891 33.7444C45.9625 33.583 46.0782 33.4428 46.2259 33.3385C46.3737 33.2341 46.5481 33.1694 46.731 33.151C46.9165 33.1612 47.0933 33.2297 47.2336 33.3457C47.2993 33.4074 47.3516 33.4809 47.3874 33.5619C47.4232 33.6429 47.4418 33.7298 47.4422 33.8177V34.4844C47.4422 34.838 47.2947 35.1771 47.0321 35.4272C46.7696 35.6772 46.4135 35.8177 46.0422 35.8177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6422 42.4844H40.8422C41.2135 42.4844 41.5696 42.379 41.8321 42.1915C42.0947 42.0039 42.2422 41.7496 42.2422 41.4844C42.2422 41.2192 42.0947 40.9648 41.8321 40.7773C41.5696 40.5897 41.2135 40.4844 40.8422 40.4844H29.6422C29.2709 40.4844 28.9148 40.5897 28.6522 40.7773C28.3897 40.9648 28.2422 41.2192 28.2422 41.4844C28.2422 41.7496 28.3897 42.0039 28.6522 42.1915C28.9148 42.379 29.2709 42.4844 29.6422 42.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4297 40.4844H46.6172C46.2525 40.4844 45.9028 40.6198 45.6449 40.861C45.3871 41.1021 45.2422 41.4291 45.2422 41.7701C45.2422 42.1111 45.3871 42.4381 45.6449 42.6792C45.9028 42.9203 46.2525 43.0558 46.6172 43.0558H51.4297C51.9767 43.0558 52.5013 43.259 52.8881 43.6207C53.2749 43.9823 53.4922 44.4729 53.4922 44.9844V45.6272C53.4922 45.9682 53.3473 46.2953 53.0895 46.5364C52.8316 46.7775 52.4819 46.9129 52.1172 46.9129C51.7525 46.9129 51.4028 46.7775 51.1449 46.5364C50.8871 46.2953 50.7422 45.9682 50.7422 45.6272C50.7422 45.2862 50.5973 44.9592 50.3395 44.7181C50.0816 44.477 49.7319 44.3415 49.3672 44.3415C49.0025 44.3415 48.6528 44.477 48.3949 44.7181C48.1371 44.9592 47.9922 45.2862 47.9922 45.6272C47.9922 46.6502 48.4268 47.6313 49.2004 48.3546C49.974 49.078 51.0232 49.4844 52.1172 49.4844C53.2112 49.4844 54.2604 49.078 55.034 48.3546C55.8076 47.6313 56.2422 46.6502 56.2422 45.6272V44.9844C56.2422 43.7909 55.7352 42.6463 54.8326 41.8024C53.9301 40.9585 52.706 40.4844 51.4297 40.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9922 44.4844H29.6589C29.2831 44.4844 28.9228 44.6249 28.6571 44.8749C28.3914 45.1249 28.2422 45.4641 28.2422 45.8177C28.2422 46.1713 28.3914 46.5105 28.6571 46.7605C28.9228 47.0106 29.2831 47.151 29.6589 47.151H40.9922C41.3679 47.151 41.7282 47.2915 41.9939 47.5416C42.2596 47.7916 42.4088 48.1308 42.4088 48.4844V49.151C42.4088 49.3256 42.3361 49.4931 42.2063 49.6177C42.0658 49.7352 41.8879 49.8055 41.7005 49.8177C41.5154 49.7993 41.3389 49.7346 41.1895 49.6303C41.04 49.5259 40.9229 49.3857 40.8505 49.2244C40.6833 48.9075 40.3892 48.6662 40.033 48.5534C39.6767 48.4406 39.2874 48.4657 38.9508 48.623C38.6141 48.7804 38.3577 49.0572 38.2379 49.3925C38.118 49.7278 38.1447 50.0942 38.3118 50.411C38.613 51.0192 39.0891 51.5359 39.6863 51.9023C40.2835 52.2688 40.9778 52.4704 41.6906 52.4844H41.7076C42.642 52.4713 43.5357 52.122 44.2052 51.5084C44.5349 51.1994 44.7963 50.832 44.9743 50.4274C45.1523 50.0228 45.2433 49.589 45.2422 49.151V48.4844C45.2422 47.4235 44.7944 46.4061 43.9974 45.6559C43.2004 44.9058 42.1193 44.4844 40.9922 44.4844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4641 28.3915L51.8826 22.8101C50.1568 21.0841 47.3604 21.0841 45.6345 22.8101L40.0512 28.3915C38.3254 30.1174 38.3254 32.9138 40.0512 34.6397L45.6327 40.2212C47.3585 41.9471 50.1549 41.9471 51.8808 40.2212L57.4622 34.6397C59.1881 32.9138 59.1881 30.1174 57.4641 28.3915ZM50.4479 35.9186C50.4479 36.852 49.691 37.6089 48.7577 37.6089C47.8243 37.6089 47.0675 36.852 47.0675 35.9186V35.5806C47.0675 34.6472 45.8039 39.4948 46.7373 39.4948C47.6707 39.4948 50.4479 37.6204 50.4479 38.5537V35.9186ZM50.4479 31.1184C50.4479 32.0518 49.691 32.8086 48.7577 32.8086C47.8243 32.8086 51.8826 33.0948 51.8826 32.1615L51.8808 28.8281C51.8808 27.8947 51.1373 26.1615 52.0706 26.1615C53.004 26.1615 50.4479 26.1792 50.4479 27.1126V31.1184Z",
    fill: "#1B3E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2726 29.6413L51.0865 25.4552C49.7921 24.1608 47.6949 24.1608 46.4005 25.4552L42.213 29.6413C40.9186 30.9357 40.9186 33.033 42.213 34.3274L46.3991 38.5136C47.6935 39.808 49.7907 39.808 51.0851 38.5136L55.2712 34.3274C56.5656 33.033 56.5656 30.9357 55.2726 29.6413ZM50.0105 35.2866C50.0105 35.9867 49.4428 36.5543 48.7428 36.5543C48.0428 36.5543 47.4752 35.9867 47.4752 35.2866V35.0331C47.4752 34.3331 48.0428 33.7654 48.7428 33.7654C49.4428 33.7654 50.0105 34.3331 50.0105 35.0331V35.2866ZM50.0105 31.6865C50.0105 32.3865 49.4428 32.9541 48.7428 32.9541C48.0428 32.9541 47.4752 32.3865 47.4752 31.6865V28.6821C47.4752 27.9821 48.0428 27.4144 48.7428 27.4144C49.4428 27.4144 50.0105 27.9821 50.0105 28.6821V31.6865Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1908_26811",
    x: 0.5,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1908_26811",
    x: 22.2422,
    y: 19.5156,
    width: 42.5146,
    height: 42.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26811",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_26811",
    x1: 43.5,
    y1: 12,
    x2: 43.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_26811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintAirQualityComplaints);
export default __webpack_public_path__ + "static/media/ComplaintAirQualityComplaints.f3c5359b0c44ac68b4b2bcd054ac4c2d.svg";
export { ForwardRef as ReactComponent };